import { registerPlugin } from '@capacitor/core';

import type { ExampleMediaSessionPluginPlugin } from './definitions';

const ExampleMediaSessionPlugin = registerPlugin<ExampleMediaSessionPluginPlugin>('ExampleMediaSessionPlugin', {
  web: () => import('./web').then((m) => new m.ExampleMediaSessionPluginWeb()),
});

export * from './definitions';
export { ExampleMediaSessionPlugin };
